<template>
  <!--
  طریقه استفاده
  <html-editor :htmlValue="html" @htmlChange="a=>this.html = a"></html-editor>
 -->
  <div>
    <div id="toolbar-container"></div>
    <div
      class="ck ck-toolbar ck-toolbar_grouping ck-reset_all ck-rounded-corners"
    >
      <file-manager @selected="uploadImage"></file-manager>
    </div>
    <div id="editor"></div>

    <v-dialog v-model="imageUploaderDialog">
      <v-card>
        <v-card-title>اضافه کردن عکس</v-card-title>
        <v-card-text>این قسمت برای مدیریت فایل ها میباشد</v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import DecoupledEditor from "@/assets/ckeditor";
import UploadAdapter from "@/MyUploadAdapter";
import FileManager from "./FileManager.vue";
function MyCustomUploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    // Configure the URL to the upload script in your back-end here!
    var baseUrl = this.$store.state.urls.file + "/api/v1/files";

    return new UploadAdapter(loader, baseUrl);
  };
}
export default {
  name: "html-editor",
  components: {
    FileManager,
  },
  props: {
    htmlValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      imageUploaderDialog: false,
      editor: null,
    };
  },
  created() {
    setTimeout(() => {
      if (this.htmlValue) {
        this.editor.setData(this.htmlValue);
      }
    }, 300);
  },
  mounted() {
    this.initialCkeditor();
  },
  methods: {
    uploadImage(image) {
      if (this.htmlValue == null) {
        this.editor.setData(
          `<img alt='${image.file.alt}' src='${image.file.fileUrl}'></img>`
        );
      } else {
        this.editor.setData(
          this.htmlValue +
            `<img alt='${image.file.alt}' src='${image.file.fileUrl}'></img>`
        );
      }
    },
    initialCkeditor() {
      let app = this;
      DecoupledEditor.create(document.querySelector("#editor"), {
        extraPlugins: [MyCustomUploadAdapterPlugin],
        fontFamily: {
          options: [
            "default",
            "Iran Sans",
            "Arial, Helvetica, sans-serif",
            "Courier New, Courier, monospace",
            "Georgia, serif",
            "Lucida Sans Unicode, Lucida Grande, sans-serif",
            "Tahoma, Geneva, sans-serif",
            "Times New Roman, Times, serif",
            "Trebuchet MS, Helvetica, sans-serif",
            "Verdana, Geneva, sans-serif",
          ],
        },
      pasteFilter: 'plain-text',


        
        language: {
          ui: "fa",
          content: "fa",
        },
      })
        .then((editor) => {
          app.editor = editor;
          const toolbarContainer = document.querySelector("#toolbar-container");
          toolbarContainer.appendChild(editor.ui.view.toolbar.element);
          editor.ui.focusTracker.on(
            "change:isFocused",
            (evt, name, isFocused) => {
              if (!isFocused) {
                let temp = editor.getData();
                /*این شرط برای اینه که موقع آپلود عکس به مشکل نخوره */ if (
                  !temp.includes("<img>")
                ) {
                  app.$emit("htmlChange", temp);
                }
              }
            }
          );
        })
        .catch((error) => {
          console.error(error + "این ارور برای لود کردن ادیتور است .");
        });
    },
  },
  watch: {
    htmlValue(after, before) {
      this.editor.setData(after);
    },
  },
};
</script>
<style scoped>
.v-application ul,
.v-application ol {
  padding-right: 24px;
}
#editor {
  border: 1px solid #8080804d;
  padding: 0em 2em 1em 2em;
}
</style>
